<template lang="pug">
  .overlay-ads(v-if="available")
    .img-container
      img(:src="adContent.ImageUrl")
    a.overlay-link(:href="adContent.LinkUrl")
    .close(
      ref="close",
      @click="closeAds()"
      )
      .close-countdown {{localCountdown}}
        span s
      .close-text 跳過
</template>

<script>
import { setInterval, clearInterval } from 'timers';
export default {
  props:{
    adContent:{
      type: Object,
      required: true,
      default: function(){
        return {}
      }
    },
    available:{
      type: Boolean,
      required: true,
      default: false
    },
    countdown:{
      type: Number,
      required: true,
      default: 5
    }
  },
  data(){
    return{
      countdownFunction: null,
      localCountdown: 0
    }
  },
  methods:{
    timer(){
      let _this = this;
      this.countdownFunction = setInterval(()=>{
        console.log(_this.localCountdown)
        if(_this.localCountdown>0){
          _this.localCountdown -= 1;
        }else{
          _this.closeAds();
          clearInterval(_this.countdownFunction);
          _this.countdownFunction = null;
        }
      },1000)
    },
    // // 倒數計時自動關閉
    // countDownClose(){
    //   console.log('countDownClose');
    //   let _this = this
    //   var interval = setInterval(function(){
    //     if(_this.localCountdown>0){
    //       _this.localCountdown -= 1
    //       console.log(_this.localCountdown)
    //     }else{
    //       _this.closeAds();
    //       window.clearInterval(interval);
    //     }
    //   },1000)
    // },
    // 關閉按鈕被觸及
    closeAds(){
      this.$emit('closeAds');
      console.log('ads close')
    }
  },
  beforeMount(){
    this.localCountdown = this.countdown;
  },
  mounted(){
    this.timer();
  },
}
</script>

<style>

</style>
